import React, { useEffect, useState } from 'react';
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Paper from '@material-ui/core/Paper'
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { Icon } from 'react-icons-kit'
import { login } from 'react-icons-kit/iconic/login'
import { logout } from 'react-icons-kit/iconic/logout'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import FrTableList from '../components/FrTableList'
import FrCheckBox from '../components/FrCheckBox'

import api from '../services/api'
import consultaCep from '../services/consultaCep'
import { paramsToObject, validarCPF, onlyNumbers, removeSpecialChar } from '../utils/functions'
import { mCPF, mTel, mCEP, mData } from '../utils/masks'

import './styles/RegSuppliers.css';
import './styles/DefaultReg.css';
import './styles/VendaExterna.css';
import FooterDelphus from '../components/FooterDelphus';
import { isMobile } from 'react-device-detect';
import logo from '../imgs/logo4.png'

const KsaSwitch = withStyles({
  switchBase: {
    color: '#F1873B',
    '&$checked': {
      color: '#F1873B',
    },
    '&$checked + $track': {
      backgroundColor: '#ed721a',
    },
  },
  checked: {},
  track: {},
})(Switch);

const swal = withReactContent(Swal)

function Propostas() {
  const [hide, setHide] = useState(true);
  const [data, setData] = useState({})
  const [replicaEndereco, setReplicaEndereco] = useState(false)
  const [erroDataNasc, setErroDataNasc] = useState(false)
  const [erroCpf, setErroCpf] = useState(false)
  const [erroCpfResponsavel, setErroCpfResponsavel] = useState(false)
  const [erroCpfConjuge, setErroCpfConjuge] = useState(false)
  const [erroCpfVendedor, setErroCpfVendedor] = useState(false)
  const [erroCep, setErroCep] = useState(false)
  const [erroCepCobranca, setErroCepCobranca] = useState(false)
  const [ErroCelularContato, setErroCelularContato] = useState(false)
  const [ErroCelularCobrança, setErroCelularCobrança] = useState(false)
  const [erroEmail, setErroEmail] = useState(false)
  const [updateType, setUpdateType] = useState(false)
  const [comboGrauParentesco, setComboGrauParentesco] = useState([{ value: '', display: '' }])
  const [comboCidades, setComboCidades] = useState([{ value: '', display: '' }])
  const [comboEstados, setComboEstados] = useState([{ value: '', display: '' }])
  const [comboGeneros, setComboGeneros] = useState([{ value: 'M', display: 'Masculino' }, { value: 'F', display: 'Feminino' }, { value: 'O', display: 'Outros' }])
  const [comboEstadoCivil, setComboEstadoCivil] = useState([{ value: 'S', display: 'Solteiro(a)' }, { value: 'C', display: 'Casado(a)' }, { value: 'V', display: 'Viúvo(a)' }, { value: 'D', display: 'Divorciado(a)' }, { value: 'O', display: 'Outros' }])
  const [comboPlanos, setComboPlanos] = useState([{ value: '', display: '' }])
  const [comboProfissoes, setComboProfissoes] = useState([{ value: '', display: '' }])
  const [comboPagamentos, setComboPagamentos] = useState([{ value: 'P', display: 'Boleto' }, { value: 'C', display: 'Cartão' }])
  const [comboBancos, setComboBancos] = useState([{ value: '', display: '' }])
  const [comboVendedores, setComboVendedores] = useState([{ value: '', display: '' }])
  const [comboBandeiraCartao, setComboBandeiraCartao] = useState([{ value: '', display: '' }])
  const [comboCidadesCob, setComboCidadesCob] = useState([{ value: '', display: '' }])
  const [comboDiaVencimento, setComboDiaVencimento] = useState([{ value: 5, display: '5' }, { value: 10, display: '10' }, { value: 15, display: '15' }, { value: 20, display: '20' }, { value: 25, display: '25' }])
  const [blockCidadesCob, setBlockCidadesCob] = useState(true)
  const [blockCidades, setBlockCidades] = useState(true)
  const [blockPlano, setBlockPlano] = useState(true)
  const [plano, setPlano] = useState([{ MENSALIDADE: '' }])
  const [coberturasColumns, setCoberturasColumns] = useState([
    { id: 'DESCRICAO', numeric: false, label: 'Coberturas' },
    { id: 'LIMITE_VALOR', numeric: true, label: 'Valor' }
  ])
  const [coberturas, setCoberturas] = useState([])
  const [columnsBeneficiarios, setColumnsBeneficiarios] = useState([
    { id: 'NOME', numeric: true, label: 'Nome', align: 'left', minWidth: 400 },
    { id: 'GRAU_PARENTESCO', numeric: false, label: 'Grau de Parentesco', align: 'left', minWidth: 200 },
    { id: 'PARTICIPACAO', numeric: true, label: '% Participação', align: 'left', minWidth: 200 },
  ])
  const [beneficiarios, setBeneficiarios] = useState([])
  const [currentUser, setCurrentUser] = useState(null)
  const [currentSeller, setCurrentSeller] = useState(null)
  // const [gpl, setGpl] = useState(null)

  useEffect((e) => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      // if (query.grupo) {
      setCurrentSeller(null)
      

      if (query.cpf) {
        const auxValues = { ...data };
        auxValues['CPF_VENDEDOR'] = query.cpf;
        setData(auxValues);
      }

      swal.close()
      // } else {
      //   swal.close()
      //   setTimeout(function () {
      //     swal.fire({
      //       title: 'Erro!',
      //       text: "Grupo de Planos não informado. Selecione um grupo de planos no nosso site!",
      //       icon: 'warning',
      //     }).then((result) => {
      //       window.history.back()
      //     })
      //   }, 500)
      // }
    }

    document.title = 'KSA Clube - Compre On-line';
    fetchData()
  }, [])

  useEffect(() => {
    const fetchIndFam = async () => {
      if (data.IND_FAM && (data.IND_FAM !== '')) {
        swal.fire({
          html: <FrLoading text="Buscando planos..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        setComboPlanos(await api.getComboData('planos', null, 'ind_fam=' + data.IND_FAM + '&exclusivo=N' ))
        setBlockPlano(false)
        setData({ ...data, FK_PLA: null })
        swal.close()
      } else {
        setPlano([{ MENSALIDADE: '' }])
        setCoberturas([])
        setData({ ...data, FK_PLA: null })
        setBlockPlano(true)
      }
    }

    fetchIndFam()

  }, [data.IND_FAM])

  useEffect(() => {
    const fetchPlano = async () => {
      if (data.FK_PLA > 0) {
        swal.fire({
          html: <FrLoading text="Buscando informações do plano..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        api.get('planos?id=' + data.FK_PLA).then(r => {
          if (r.data[0]) {
            setPlano(r.data[0])
            console.log(r.data[0])
            api.get('planos/coberturas?id=' + data.FK_PLA).then(r => {
              if (r.data[0]) {
                setCoberturas(r.data)
                swal.close()
              } else {
                setCoberturas([])
                swal.close()
              }
            })
          } else {
            setPlano([{ MENSALIDADE: '' }])
            setCoberturas([])
            swal.close()
            
          }
        })

      } else {
        setPlano([{ MENSALIDADE: '' }])
        setCoberturas([])
        swal.close()
      }
    }

    fetchPlano()
  }, [data.FK_PLA])

  useEffect(() => {
    const fetchCidades = async () => {
      if (data.FK_EST > 0) {
        swal.fire({
          html: <FrLoading text="Buscando Cidades..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        let cidades = await api.getComboData('cidades', data.FK_EST)
        setComboCidades(cidades)
        if (data.CIDADE_CEP) {
          let cidade = cidades.find(item => String(item.display).normalize('NFD').replace(/[\u0300-\u036f]/g, "") === data.CIDADE_CEP.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
          if (cidade) {
            const auxValues = { ...data };
            auxValues['FK_CID'] = cidade.value
            if (replicaEndereco) {
              auxValues['CEP_COB'] = auxValues['CEP_COB']
              auxValues['END_COB'] = auxValues['ENDERECO']
              auxValues['NUMERO_COB'] = auxValues['NUMERO']
              auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
              auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
              auxValues['FK_EST_COB'] = auxValues['FK_EST']
              auxValues['FK_CID_COB'] = auxValues['FK_CID']
            }
            setData(auxValues)
          }
        }

        swal.close()
        setBlockCidades(false)
      } else setBlockCidades(true)
    }

    fetchCidades()
  }, [data.FK_EST])

  useEffect(() => {
    const fetchCidadesCob = async () => {
      if (data.FK_EST_COB > 0) {
        swal.fire({
          html: <FrLoading text="Buscando Cidades..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        let cidades = await api.getComboData('cidades', data.FK_EST_COB)
        setComboCidadesCob(cidades)

        if (data.CIDADE_COB_CEP) {
          let cidade = cidades.find(item => String(item.display).normalize('NFD').replace(/[\u0300-\u036f]/g, "") === data.CIDADE_COB_CEP.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
          if (cidade) {
            const auxValues = { ...data };
            auxValues['FK_CID_COB'] = cidade.value
            setData(auxValues)
          }
        }
        swal.close()
        setBlockCidadesCob(false)
      } else setBlockCidadesCob(true)
    }

    fetchCidadesCob()
  }, [data.FK_EST_COB])

  function handleDataNasc(e) {
    e.preventDefault()
    if (e.target.value.length > 10) {
      setErroDataNasc(true)
      swal.fire('Data de Nascimento inválida', 'Data de Nascimento inválida!', 'warning')
    } else {
      let date = moment.utc(e.target.value).startOf("day")
      let nowDate = moment.utc(new Date()).endOf("day")
      console.log(data)
      if (data.LIBERA_IDADE == 'S') return setErroDataNasc(false)
      if (moment(nowDate).diff(date, 'years') >= 70) {
        setErroDataNasc(true)
        swal.fire('Data de Nascimento inválida', 'Idade limite ultrapassada!', 'warning')
      } else setErroDataNasc(false)
    }
  }

  function handleDataNascConjuge(e) {
    e.preventDefault()
    if (e.target.value.length > 10) {
      setErroDataNasc(true)
      swal.fire('Data de Nascimento inválida', 'Data de Nascimento inválida!', 'warning')
    }
    else setErroDataNasc(false)
  }

  async function handleCpf(e) {
    e.preventDefault();
    if (!validarCPF(e.target.value) && (String(e.target.value) !== '')) {
      switch (e.target.name) {
        case 'CPF': setErroCpf(true)
        case 'CPF_CONJUGE': setErroCpfConjuge(true)
        case 'CPF_RESPONSAVEL': setErroCpfResponsavel(true)
        case 'CPF_VENDEDOR': setErroCpfVendedor(true)
      }
      swal.fire('CPF inválido', 'Informe um CPF válido!', 'warning')
    } else {
      switch (e.target.name) {
        case 'CPF':
          setErroCpf(false)
          if (String(e.target.value) !== '') {
            await api.get('propostas?cpf_existente=' + e.target.value).then(r => {
              if (r.data.length > 0) {
                setErroCpf(true)
                swal.fire('CPF inválido', 'Já existe proposta ativa para este CPF!', 'warning')
              }
            })
          }
          break
        case 'CPF_CONJUGE':
          setErroCpfConjuge(false)
          break;
        case 'CPF_RESPONSAVEL':
          setErroCpfResponsavel(false)
          break;
        case 'CPF_VENDEDOR':
          setErroCpfVendedor(false)
          break;

      }

      if ((e.target) && (e.target.name == 'CPF')) {
        api.get('/propostas/temPropostaAtiva?CPF=' + e.target.value).then(r => {
          if (r.data) {
            swal.fire(r.data)
          }
        })
      }
    }
  }

  function handleEmail(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value.indexOf('@') === -1) {
        setErroEmail(true)
        swal.fire('Email inválido', 'Informe um email válido!', 'warning')
      } else setErroEmail(false)
    }
  }

  function handleCelularContato(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value.length !== 14) {
        setErroCelularContato(true)
        swal.fire('Celular inválido', 'Informe um celular válido!', 'warning')
      } else setErroCelularContato(false)
    }
  }

  function handleCelularCobrança(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value.length !== 14) {
        setErroCelularCobrança(true)
        swal.fire('Celular inválido', 'Informe um celular válido!', 'warning')
      } else setErroCelularCobrança(false)
    }
  }

  function handleCep(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value) {
        swal.fire({
          html: <FrLoading text="Buscando CEP..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        consultaCep.get('/' + onlyNumbers(e.target.value) + '/json').then(r => {
          console.log(r)
          if (r.data.erro) {
            setErroCep(true)
            swal.close()
            swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
          } else {
            setErroCep(false)
            const auxValues = { ...data };
            auxValues['ENDERECO'] = r.data.logradouro;
            auxValues['BAIRRO'] = r.data.bairro;
            let estado = comboEstados.find((item) => item.UF === r.data.uf)
            if (estado) auxValues['FK_EST'] = estado.value
            auxValues['CIDADE_CEP'] = String(r.data.localidade).toUpperCase()
            if (replicaEndereco) {
              auxValues['CEP_COB'] = auxValues['CEP_COB']
              auxValues['END_COB'] = auxValues['ENDERECO']
              auxValues['NUMERO_COB'] = auxValues['NUMERO']
              auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
              auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
              auxValues['FK_EST_COB'] = auxValues['FK_EST']
              auxValues['FK_CID_COB'] = auxValues['FK_CID']
            }
            // let cidade = comboCidades.find((item) => item.display.toUpperCase() === r.data.cidade.toUpperCase())
            // auxValues['FK_CID'] = cidade.value
            swal.close()
            setData(auxValues)
          }
        }).catch(err => {
          setErroCep(true)
          swal.close()
          swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
        })
      }
    }
  }

  function handleCepCobranca(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value) {
        swal.fire({
          html: <FrLoading text="Buscando CEP..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        consultaCep.get('/' + onlyNumbers(e.target.value) + '/json').then(r => {
          console.log(r)
          if (r.data.erro) {
            setErroCepCobranca(true)
            swal.close()
            swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
          } else {
            setErroCepCobranca(false)
            const auxValues = { ...data };
            auxValues['END_COB'] = r.data.logradouro;
            auxValues['BAIRRO_COB'] = r.data.bairro;
            let estado = comboEstados.find((item) => item.UF === r.data.uf)
            if (estado) auxValues['FK_EST_COB'] = estado.value
            auxValues['CIDADE_COB_CEP'] = String(r.data.localidade).toUpperCase()
            // let cidade = comboCidades.find((item) => item.display.toUpperCase() === r.data.cidade.toUpperCase())
            // auxValues['FK_CID'] = cidade.value
            swal.close()
            setData(auxValues)
          }
        }).catch(err => {
          setErroCepCobranca(true)
          swal.close()
          swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
        })
      }
    }
  }

  function consistData(data) {
    let required = [
      { fieldName: 'RAZAO_SOCIAL', display: 'Nome' },
      { fieldName: 'CPF', display: 'CPF' },
      { fieldName: 'DATA_NASC', display: 'Data de Nascimento' },
      { fieldName: 'SEXO', display: 'Gênero' },
      { fieldName: 'ESTADO_CIVIL', display: 'Estado Civil' },
      { fieldName: 'FK_PRF', display: 'Profissão' },
      { fieldName: 'CEP', display: 'CEP' },
      { fieldName: 'ENDERECO', display: 'Rua' },
      { fieldName: 'NUMERO', display: 'Número' },
      { fieldName: 'BAIRRO', display: 'Bairro' },
      { fieldName: 'FK_CID', display: 'Cidade' },
      { fieldName: 'FK_EST', display: 'Estado' },
      { fieldName: 'CELULAR', display: 'Celular para Contato' },
      // { fieldName: 'FONE_RESPONSAVEL', display: 'Celular para Cobrança' },
      { fieldName: 'EMAIL', display: 'Email' },
      { fieldName: 'CEP_COB', display: 'CEP (End. Cobrança)' },
      { fieldName: 'END_COB', display: 'Rua (End. Cobrança)' },
      { fieldName: 'NUMERO_COB', display: 'Número (End. Cobrança)' },
      { fieldName: 'BAIRRO_COB', display: 'Bairro (End. Cobrança)' },
      { fieldName: 'FK_CID_COB', display: 'Cidade (End. Cobrança)' },
      { fieldName: 'FK_EST_COB', display: 'Estado (End. Cobrança)' },
      { fieldName: 'DIA_VENCIMENTO', display: 'Dia de Vencimento' },
      { fieldName: 'RG', display: 'RG' },
      { fieldName: 'ORGAO_RG', display: 'Órgão Exp.RG' },
      { fieldName: 'DATA_RG', display: 'Data Exp.RG' },
      { fieldName: 'FK_PLA', display: 'Plano' }
    ]

    let errors = []

    required.forEach((curr, index) => {
      if (!data[curr.fieldName]) return errors.push(curr.display)
    })

    if (erroCpf && (errors.indexOf('CPF') === -1)) errors.push('CPF')
    if (erroDataNasc && (errors.indexOf('Data de Nascimento') === -1)) errors.push('Data de Nascimento')
    if (erroCpfConjuge) errors.push('CPF (Conjuge)')
    if (erroCpfResponsavel) errors.push('CPF (Cobrança)')
    if (ErroCelularContato) errors.push('Celular para Contato')
    if (ErroCelularCobrança) errors.push('Celular para Cobrança')
    if (erroCep && (errors.indexOf('CEP') === -1)) errors.push('CEP')
    if (erroEmail && (errors.indexOf('Email') === -1)) errors.push('Email')
    if (erroCepCobranca && (errors.indexOf('CEP (End. Cobrança)') === -1)) errors.push('CEP (End. Cobrança)')


    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (data.checkDeclaracao) {
      swal.fire({
        title: 'ATENÇÃO',
        text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then((result) => {
        if (result.value) {
          const auxValues = { ...data };
          // auxValues.CPF = onlyNumbers(auxValues.CPF)
          auxValues.FK_USU_EXTERNO = null
          auxValues.FONE1 = onlyNumbers(auxValues.FONE1)
          auxValues.FONE_RESPONSAVEL = onlyNumbers(auxValues.FONE_RESPONSAVEL)
          auxValues.CELULAR = onlyNumbers(auxValues.CELULAR)
          auxValues.CEP = onlyNumbers(auxValues.CEP)
          auxValues.CEP_COB = onlyNumbers(auxValues.CEP_COB)
          auxValues.beneficiarios = beneficiarios
          if (beneficiarios.length > 0) {
            let totalPorcentagem = beneficiarios.reduce((porcentagemTotal, item) => Number(Number(porcentagemTotal) + Number(item.PARTICIPACAO)), 0)
            if (totalPorcentagem !== 100) {
              swal.fire('Porcentagem inválida', 'O somatório das porcentagens deve ser 100%!', 'warning')
              return
            }
          }

          api.get('/propostas/temPropostaAtiva?CPF=' + auxValues.CPF, auxValues).then(r => {
            console.log(r.data)
            if (r.data) {
              swal.fire(r.data)
            }
            else {

              let errors = consistData(auxValues)

              if (errors.length === 0) {
                if (updateType) {
                  api.post('/propostas/edit', auxValues).then(r => {
                    if (r.status === 200) {
                      swal.fire({
                        title: 'Registro Alterado',
                        text: "O registro foi alterado com sucesso!",
                        icon: 'success',
                      }).then((result) => {
                        if (result.value) {
                          window.history.back()
                        }
                      })
                    } else {
                      swal.fire({
                        title: 'Erro!',
                        text: "O registro não foi alterado!",
                        icon: 'warning',
                      })
                    }
                  })
                } else {
                  swal.fire({
                    html: <FrLoading text="Processando..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                  })
                  api.post('/propostas/add?vendaexterna=true', auxValues).then(r => {
                    console.log(r.data)
                    if (r.data == "Já existe uma proposta ativa para este CPF!") {
                      swal.fire({
                        title: 'Erro!',
                        text: r.data,
                        icon: 'warning',
                      })

                    } else
                      if (r.status === 200) {
                        swal.close()
                        swal.fire({
                          title: auxValues.RAZAO_SOCIAL + ', parabéns pela adesão ao KSA Clube!',
                          // text: "A proposta de nº " + r.data.PK_PRP + " foi enviada ao Clube.\nEnviamos o link para prosseguir com o pagamento através do email " + auxValues.EMAIL + ".\nAgradeçemos a confiança!",
                          text: "A proposta de nº " + r.data.PK_PRP + " foi enviada ao Clube.\nAgradeçemos a confiança!",
                          icon: 'success',
                        }).then((result) => {
                          if (result.value) {
                            let url = window.location.href

                            if (url.indexOf('?') == -1) {
                              window.location.href = window.location.href + '?cpf=' + data.CPF_VENDEDOR
                            } else
                              window.location.reload()
                            // swal.fire({
                            //   text: "Deseja enviar o link através do Whatsapp também?",
                            //   icon: 'question',
                            //   showCancelButton: true,
                            //   confirmButtonColor: '#3085d6',
                            //   cancelButtonColor: '#d33',
                            //   confirmButtonText: 'Sim',
                            //   cancelButtonText: 'Não'
                            // }).then((result) => {
                            //   if (result.value) {

                            //     let target = `https://wa.me/55` + auxValues.CELULAR + '/?text=' + encodeURIComponent('Olá! Tudo bem? Segue link para prosseguir com o pagamento da adesão ao KSA Clube. Link: ' + r.data.url)

                            //     window.location.href = target
                            //   } else window.location.reload()
                            // })


                          }
                        })
                      } else {
                        swal.fire({
                          title: 'Erro!',
                          text: "O registro não foi adicionado!",
                          icon: 'warning',
                        })
                      }
                  })
                }
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "Verifique o(s) campo(s) " + errors.join(', '),
                  icon: 'warning',
                })
              }
            }
          })
        }
      })
    } else {
      swal.fire({
        title: 'Atenção!',
        text: "Para finalizar a adesão do plano você deve marcar que está de acordo com a declaração no final da página.",
        icon: 'warning',
      })
    }
  }

  function handleVoltar(e) {
    e.preventDefault();
    window.history.back()
  }

  const adicionarBeneficiario = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    if (auxValues.BEN_NOME && auxValues.BEN_PORCENTAGEM) {
      let beneficiario = { NOME: String(auxValues.BEN_NOME).toUpperCase(), FK_GRA: auxValues.BEN_GRAU_PARENTESCO, PARTICIPACAO: auxValues.BEN_PORCENTAGEM }
      const beneficiariosList = [...beneficiarios]
      console.log(beneficiariosList)
      let valorAdicionado = beneficiariosList.reduce((porcentagemTotal, item) => Number(Number(porcentagemTotal) + Number(item.PARTICIPACAO)), 0)
      let valorAdicionar = Number(auxValues.BEN_PORCENTAGEM)
      let total = valorAdicionado + valorAdicionar
      console.log(total, Number(auxValues.BEN_PORCENTAGEM), valorAdicionado)
      if (total > 100) {
        swal.fire('Porcentagem inválida', 'O somatório das porcentagens não pode ultrapassar 100%!', 'warning')
      } else {
        beneficiariosList.push(beneficiario)
        auxValues.BEN_NOME = null
        auxValues.BEN_GRAU_PARENTESCO = null
        auxValues.BEN_PORCENTAGEM = null
        setData(auxValues)
        setBeneficiarios(beneficiariosList)
        console.log(beneficiariosList)
      }
    }
  }

  const excluirBeneficiario = (id) => {
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja excluir o registro selecionado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      const beneficiariosList = [...beneficiarios]
      beneficiariosList.splice(id, 1)
      setBeneficiarios(beneficiariosList)
      swal.fire({
        title: 'Registro Excluído',
        text: "O registro foi excluído com sucesso!",
        icon: 'success',
      })
    })
  }

  const handleChangeReplicaEndereco = (e) => {
    setReplicaEndereco(e.target.checked)
    if (e.target.checked) {
      const auxValues = { ...data };
      auxValues['CEP_COB'] = auxValues['CEP']
      auxValues['END_COB'] = auxValues['ENDERECO']
      auxValues['NUMERO_COB'] = auxValues['NUMERO']
      auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
      auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
      auxValues['FK_EST_COB'] = auxValues['FK_EST']
      auxValues['FK_CID_COB'] = auxValues['FK_CID']
      setData(auxValues);
    }
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {

      case 'DATA_NASC':
      case 'DATA_RG':
      case 'DATA_NASC_CONJUGE':
        if (isMobile)
          auxValues[e.target.name] = mData(e.target.value)
        else
          auxValues[e.target.name] = e.target.value
        break

      case 'CPF':
      case 'CPF_RESPONSAVEL':
      case 'CPF_CONJUGE':
      case 'CPF_VENDEDOR':
        auxValues[e.target.name] = mCPF(e.target.value)
        break

      case 'FONE1':
      case 'CELULAR':
      case 'FONE_RESPONSAVEL':
        auxValues[e.target.name] = mTel(e.target.value)
        break

      case 'CEP':
      case 'CEP_COB':
        auxValues[e.target.name] = mCEP(e.target.value)
        if (replicaEndereco) {
          auxValues['CEP_COB'] = auxValues['CEP']
        }
        break

      case 'checkDeclaracao':
        auxValues[e.target.name] = e.target.checked
        break

      default:
        auxValues[e.target.name] = e.target.value
        if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
        if (replicaEndereco) {
          auxValues['END_COB'] = auxValues['ENDERECO']
          auxValues['NUMERO_COB'] = auxValues['NUMERO']
          auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
          auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
          auxValues['FK_EST_COB'] = auxValues['FK_EST']
          auxValues['FK_CID_COB'] = auxValues['FK_CID']
        }
        break
    }

    setData(auxValues);
  };


  useEffect(() => {
    const fetchVendedor =  () => {
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if ((data.CPF_VENDEDOR) && (query.cpf)) {
        api.get('vendedores?cpf=' + onlyNumbers(data.CPF_VENDEDOR)).then(r => {
          console.log(r)
          if (r.data.res && r.data.res[0] && r.data.res[0].ATIVO == "S") {
            setCurrentSeller(r.data.res[0])
            const auxValues = { ...data };
            console.log(data)
            auxValues.FK_VEN = r.data.res[0].PK_PVE
            setData(auxValues)
            setHide(!hide)
          } else swal.fire('CPF não encontrado ou vendedor inativo!', 'O CPF informado não foi encontrado na nossa base ou o vendedor está inativo', 'warning')
        })
      }
    }
    fetchVendedor()
  }, [data.CPF_VENDEDOR])

  const handleVendedor = (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    let query = paramsToObject(urlParams)

    if (data.CPF_VENDEDOR && !erroCpfVendedor) {
      api.get('vendedores?cpf=' + onlyNumbers(data.CPF_VENDEDOR)).then(r => {
        console.log(r.data.res)
        if (r.data.res && r.data.res[0] && r.data.res[0].ATIVO == "S") {
          localStorage['authKSA'] = JSON.stringify({access_token: r.data.token })
          
          setCurrentSeller(r.data.res[0])
          const auxValues = { ...data };
          auxValues.FK_VEN = r.data.res[0].PK_PVE
          auxValues.LIBERA_IDADE= r.data.res[0].LIBERA_IDADE
          setData(auxValues)
          if (!query.cpf)
            swal.fire('Bem vindo(a) ' + r.data.res[0].NOME + '!', 'Você pode prosseguir com o registro agora.', 'success').then(async r=>{
              swal.fire({
                html: <FrLoading text="Carregando..." />,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
              })
              setComboPlanos(await api.getComboData('planos'))  
              setComboEstados(await api.getComboData('estados'))
              setComboProfissoes(await api.getComboData('profissoes'))
              setComboGrauParentesco(await api.getComboData('graus_parentesco'))
              setComboBancos(await api.getComboData('bancos'))
              setComboBandeiraCartao(await api.getComboData('bandeira_cartao'))
              swal.close()
            })
          setHide(!hide)
        } else swal.fire('CPF não encontrado ou vendedor inativo!', 'O CPF informado não foi encontrado na nossa base ou o vendedor está inativo', 'warning')
      })
    } else
      swal.fire('CPF - Vendedor inválido!', 'Informe um CPF do Vendedor válido', 'warning')
  }

  function handleCancel(e) {
    e.preventDefault();
    if (!updateType) {
      swal.fire({
        title: 'ATENÇÃO',
        text: "Caso cancele a inclusão, todos os dados digitados serão perdidos. Confirma?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then((result) => {
        if (result.value) {
          window.location.href = '/sistema/vendaexterna'
          setHide(!hide)
        }
      })
    } else window.location.href = '/sistema/vendaexterna'

  }

  return (
    <div className="defaultReg">
      <div className="VendaExterna">
        <form id="regForm" onSubmit={handleSubmit}>
          <Paper elevation={1} square>
            <div className="paperDiv">
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img alt="fr_logo" src={logo} title="KSA Clube" className="logo" />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ display: 'flex' }}>
                  <FrTextInput
                    error={erroCpfVendedor}
                    maxLength='14'
                    value={data.CPF_VENDEDOR || ''}
                    onChange={handleChange}
                    onBlur={handleCpf}
                    name="CPF_VENDEDOR"
                    id="CPF_VENDEDOR"
                    color="#F1873B"
                    label="CPF - Vendedor"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 200 }}
                  />
                  <button className="loginVendaButton"  > {hide ? <Icon size={20} icon={login} onClick={handleVendedor} /> : <Icon size={20} icon={logout} onClick={handleCancel} />} </button>
                </div>
                <div style={{ flex: 1, display: (currentSeller ? 'flex' : 'none'), alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
                  <FrSelect
                    value={data.IND_FAM || ''}
                    onChange={handleChange}
                    name="IND_FAM"
                    id="IND_FAM"
                    label='Tipo de Plano *'
                    data={[{ display: 'Familiar', value: 'F' }, { display: 'Individual', value: 'I' }]}
                    style={{ flex: 1, maxWidth: 300, minWidth: 230 }}
                    required
                    vendaExterna
                    disabled={updateType}
                  />
                  <Tooltip title={blockPlano ? 'Informe o Tipo de Plano!' : ''}>
                    <FrSelect
                      value={data.FK_PLA || ''}
                      onChange={handleChange}
                      name="FK_PLA"
                      id="FK_PLA"
                      label='Plano *'
                      data={comboPlanos}
                      style={{ flex: 1, maxWidth: 300, minWidth: 230 }}
                      required
                      vendaExterna
                      disabled={blockPlano}
                    />
                  </Tooltip>
                  {/* <button className="backToSiteButton" onClick={handleVoltar}>Escolha outro plano</button> */}
                </div>
                <div style={{ display: (data.FK_PLA > 0 ? 'flex' : 'none'), flex: 1 }} >
                  <a style={{ fontWeight: 'bold', fontSize: '1.0rem', flex: 1 }}>{plano.MENSALIDADE ? 'Mensalidade:' : ''}</a>
                  <a style={{ fontSize: '1.0rem', marginLeft: '10px', fontFamily: 'Quicksand', flex: 1 }}>{plano.MENSALIDADE ? plano.MENSALIDADE.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : ''}</a>
                </div>
              </div>
              <div style={{ marginTop: '10px', marginBottom: '20px', display: (data.FK_PLA > 0 ? 'block' : 'none') }}>
                <FrTableList dense columns={coberturasColumns} searched={true} order={{ order: 'desc', field: 'LIMITE_VALOR' }} data={coberturas} emptyMessage="" />
              </div>
            </div>
          </Paper>
          <Zoom in={data.FK_PLA > 0}>
            <div style={{ display: (data.FK_PLA > 0 ? 'block' : 'none') }}>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Dados do Proponente:</h2>
                  <FrTextInput
                    maxLength='150'
                    value={data.RAZAO_SOCIAL || ''}
                    onChange={handleChange}
                    name="RAZAO_SOCIAL"
                    id="RAZAO_SOCIAL"
                    color="#F1873B"
                    label="Nome"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 500 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    error={erroCpf}
                    maxLength='14'
                    value={data.CPF || ''}
                    onChange={handleChange}
                    onBlur={handleCpf}
                    name="CPF"
                    id="CPF"
                    color="#F1873B"
                    label="CPF"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 180 }}
                    disabled={updateType}
                  />
                  <FrDatePicker
                    value={(data.DATA_NASC || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_NASC"
                    id="DATA_NASC"
                    color="#49573B"
                    label="Data de Nascimento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    error={erroDataNasc}
                    onBlur={handleDataNasc}
                    required
                    hidden={isMobile}
                  />

                  <FrTextInput
                    value={(data.DATA_NASC || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_NASC"
                    id="DATA_NASC"
                    color="#49573B"
                    label="Data de Nascimento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    error={erroDataNasc}
                    onBlur={handleDataNasc}
                    required
                    hidden={!isMobile}
                  />

                  <FrTextInput
                    maxLength='15'
                    value={data.RG || ''}
                    onChange={handleChange}
                    name="RG"
                    id="RG"
                    color="#F1873B"
                    label="RG"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 130 }}
                    disabled={updateType}
                    required
                  />
                  <FrTextInput
                    maxLength='15'
                    value={data.ORGAO_RG || ''}
                    onChange={handleChange}
                    name="ORGAO_RG"
                    id="ORGAO_RG"
                    color="#F1873B"
                    label="Órgão Expedidor/UF"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 160 }}
                    disabled={updateType}
                    required
                  />
                  <FrDatePicker
                    value={(data.DATA_RG || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_RG"
                    id="DATA_RG"
                    color="#49573B"
                    label="Data Exp.RG"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    required
                    hidden={isMobile}
                  />


                  <FrTextInput
                    value={(data.DATA_RG || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_RG"
                    id="DATA_RG"
                    color="#49573B"
                    label="Data Exp.RG"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    required
                    hidden={!isMobile}
                  />

                  <FrSelect
                    value={data.SEXO || ''}
                    onChange={handleChange}
                    name="SEXO"
                    id="SEXO"
                    label='Gênero *'
                    data={comboGeneros}
                    style={{ width: '100%', maxWidth: 150 }}
                    disabled={updateType}
                    required
                  />
                  <FrSelect
                    value={data.ESTADO_CIVIL || ''}
                    onChange={handleChange}
                    name="ESTADO_CIVIL"
                    id="ESTADO_CIVIL"
                    label='Estado Civil *'
                    data={comboEstadoCivil}
                    style={{ width: '100%', maxWidth: 200 }}
                    disabled={updateType}
                    required
                  />
                  <FrSelect
                    value={data.FK_PRF || ''}
                    onChange={handleChange}
                    name="FK_PRF"
                    id="FK_PRF"
                    label='Profissão *'
                    data={comboProfissoes}
                    style={{ width: '100%', maxWidth: 400 }}
                    disabled={updateType}
                    required
                  />
                </div>
              </Paper>

              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Dados Conjuge:</h2>
                  <FrTextInput
                    maxLength='150'
                    value={data.NOME_CONJUGE || ''}
                    onChange={handleChange}
                    name="NOME_CONJUGE"
                    id="NOME_CONJUGE"
                    color="#F1873B"
                    label="Nome"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 500 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    error={erroCpfConjuge}
                    maxLength='14'
                    value={data.CPF_CONJUGE || ''}
                    onChange={handleChange}
                    onBlur={handleCpf}
                    name="CPF_CONJUGE"
                    id="CPF_CONJUGE"
                    color="#F1873B"
                    label="CPF"
                    variant="outlined"
                    size="small"
                    disabled={updateType}
                    style={{ width: '100%', maxWidth: 180 }}
                  />
                  <FrDatePicker
                    value={(data.DATA_NASC_CONJUGE || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_NASC_CONJUGE"
                    id="DATA_NASC_CONJUGE"
                    color="#49573B"
                    label="Data de Nascimento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    error={erroDataNasc}
                    onBlur={handleDataNascConjuge}
                    hidden={isMobile}
                  />

                  <FrTextInput
                    value={(data.DATA_NASC_CONJUGE || '').split('T')[0]}
                    onChange={handleChange}
                    name="DATA_NASC_CONJUGE"
                    id="DATA_NASC_CONJUGE"
                    color="#49573B"
                    label="Data de Nascimento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 190 }}
                    disabled={updateType}
                    error={erroDataNasc}
                    onBlur={handleDataNascConjuge}
                    hidden={!isMobile}
                  />


                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Endereço/Contato:</h2>
                  <FrTextInput
                    maxLength='10'
                    value={data.CEP || ''}
                    error={erroCep}
                    onChange={handleChange}
                    onBlur={handleCep}
                    name="CEP"
                    id="CEP"
                    color="#F1873B"
                    label="CEP"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 100 }}
                    required
                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='100'
                    value={data.ENDERECO || ''}
                    onChange={handleChange}
                    fullWidth
                    name="ENDERECO"
                    id="ENDERECO"
                    color="#F1873B"
                    label="Rua"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 700 }}
                    required
                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.NUMERO || ''}
                    onChange={handleChange}
                    name="NUMERO"
                    id="NUMERO"
                    color="#F1873B"
                    label="Número"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 100 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.BAIRRO || ''}
                    onChange={handleChange}
                    name="BAIRRO"
                    id="BAIRRO"
                    color="#F1873B"
                    label="Bairro"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 200 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.COMPLEMENTO || ''}
                    onChange={handleChange}
                    name="COMPLEMENTO"
                    id="COMPLEMENTO"
                    color="#F1873B"
                    label="Complemento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 400 }}
                    disabled={updateType}
                  />
                  <FrSelect
                    value={data.FK_EST || ''}
                    onChange={handleChange}
                    name="FK_EST"
                    id="FK_EST"
                    label='Estado *'
                    data={comboEstados}
                    style={{ width: '100%', maxWidth: 250 }}
                    disabled={updateType}
                  />
                  <Tooltip title={blockCidades ? 'Informe um Estado antes de informar a Cidade!' : ''}>
                    <FrSelect
                      value={data.FK_CID || ''}
                      onChange={handleChange}
                      name="FK_CID"
                      id="FK_CID"
                      label='Cidade *'
                      data={comboCidades}
                      style={{ width: 250 }}
                      disabled={blockCidades}
                      required
                    />
                  </Tooltip>
                  <br />
                  <FrTextInput
                    maxLength='14'
                    value={data.FONE1 || ''}
                    onChange={handleChange}
                    name="FONE1"
                    id="FONE1"
                    color="#F1873B"
                    label="Telefone"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 160 }}

                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='14'
                    value={data.CELULAR || ''}
                    onChange={handleChange}
                    onBlur={handleCelularContato}
                    name="CELULAR"
                    id="CELULAR"
                    color="#F1873B"
                    label="Celular"
                    variant="outlined"
                    style={{ width: '100%', maxWidth: 160 }}
                    size="small"
                    disabled={updateType}
                    required
                  />
                  <FrTextInput
                    maxLength='100'
                    value={data.EMAIL || ''}
                    onChange={handleChange}
                    onBlur={handleEmail}
                    name="EMAIL"
                    id="EMAIL"
                    color="#F1873B"
                    label="Email"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 300 }}
                    required
                    disabled={updateType}
                  />
                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Endereço Cobrança:
                    <span style={{ fontSize: '1rem', paddingLeft: '30px' }}>
                      Utilizar o mesmo endereço de contato
                      <KsaSwitch
                        name="REPLICA_ENDERECO"
                        id="REPLICA_ENDERECO"
                        onChange={handleChangeReplicaEndereco}
                        checked={replicaEndereco}
                      />
                    </span>
                  </h2>

                  <FrTextInput
                    maxLength='10'
                    value={data.CEP_COB || ''}
                    error={erroCepCobranca}
                    onChange={handleChange}
                    onBlur={handleCepCobranca}
                    name="CEP_COB"
                    id="CEP_COB"
                    color="#F1873B"
                    label="CEP"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 100 }}
                    required
                    disabled={updateType || replicaEndereco}
                  />
                  <FrTextInput
                    maxLength='100'
                    value={data.END_COB || ''}
                    onChange={handleChange}
                    fullWidth
                    name="END_COB"
                    id="END_COB"
                    color="#F1873B"
                    label="Rua"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 700 }}
                    required
                    disabled={updateType || replicaEndereco}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.NUMERO_COB || ''}
                    onChange={handleChange}
                    name="NUMERO_COB"
                    id="NUMERO_COB"
                    color="#F1873B"
                    label="Número"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 100 }}
                    disabled={updateType || replicaEndereco}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.BAIRRO_COB || ''}
                    onChange={handleChange}
                    name="BAIRRO_COB"
                    id="BAIRRO_COB"
                    color="#F1873B"
                    label="Bairro"
                    variant="outlined"
                    size="small"
                    required
                    style={{ width: '100%', maxWidth: 200 }}
                    disabled={updateType || replicaEndereco}
                  />
                  <FrTextInput
                    maxLength='45'
                    value={data.COMPLEMENTO_COB || ''}
                    onChange={handleChange}
                    name="COMPLEMENTO_COB"
                    id="COMPLEMENTO_COB"
                    color="#F1873B"
                    label="Complemento"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 400 }}
                    disabled={updateType || replicaEndereco}
                  />
                  <FrSelect
                    value={data.FK_EST_COB || ''}
                    onChange={handleChange}
                    name="FK_EST_COB"
                    id="FK_EST_COB"
                    label='Estado *'
                    data={comboEstados}
                    style={{ width: '100%', maxWidth: 250 }}
                    disabled={updateType || replicaEndereco}
                  />
                  <Tooltip title={blockCidades ? 'Informe um Estado antes de informar a Cidade!' : ''}>
                    <FrSelect
                      value={data.FK_CID_COB || ''}
                      onChange={handleChange}
                      name="FK_CID_COB"
                      id="FK_CID_COB"
                      label='Cidade *'
                      data={comboCidadesCob}
                      style={{ width: 250 }}
                      // disabled={blockCidadesCob}
                      required
                      disabled={updateType || replicaEndereco}
                    />
                  </Tooltip>
                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Beneficiários:</h2>
                  <form className="tableInfo">
                    <FrTextInput
                      maxLength='100'
                      value={data.BEN_NOME || ''}
                      onChange={handleChange}
                      fullWidth
                      name="BEN_NOME"
                      id="BEN_NOME"
                      color="#F1873B"
                      label="Nome"
                      variant="outlined"
                      size="small"
                      style={{ width: '100%', maxWidth: 400 }}
                      disabled={updateType}
                    />
                    <FrSelect
                      value={data.BEN_GRAU_PARENTESCO || ''}
                      onChange={handleChange}
                      name="BEN_GRAU_PARENTESCO"
                      id="BEN_GRAU_PARENTESCO"
                      label='Grau de Parentesco'
                      data={comboGrauParentesco}
                      style={{ width: 250 }}
                      disabled={updateType}
                    />
                    <FrTextInput
                      maxLength='45'
                      value={data.BEN_PORCENTAGEM || ''}
                      onChange={handleChange}
                      name="BEN_PORCENTAGEM"
                      id="BEN_PORCENTAGEM"
                      color="#F1873B"
                      label="% Participação"
                      variant="outlined"
                      size="small"
                      style={{ width: '100%', maxWidth: 200 }}
                      disabled={updateType}
                    />
                    <button onClick={adicionarBeneficiario}>Adicionar</button>
                  </form>
                  <div style={{ marginTop: '10px' }}>
                    <FrTableList dense deleteOption deleteFunction={excluirBeneficiario} columns={columnsBeneficiarios} searched={true} data={beneficiarios} emptyMessage="Nenhum beneficiário vinculado!" />
                  </div>
                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Dados para envio de Cobrança:</h2>
                  <FrTextInput
                    maxLength='150'
                    value={data.RESPONSAVEL_FINANCEIRO || ''}
                    onChange={handleChange}
                    name="RESPONSAVEL_FINANCEIRO"
                    id="RESPONSAVEL_FINANCEIRO"
                    color="#F1873B"
                    label="Nome"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 500 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    error={erroCpfResponsavel}
                    maxLength='14'
                    value={data.CPF_RESPONSAVEL || ''}
                    onChange={handleChange}
                    onBlur={handleCpf}
                    name="CPF_RESPONSAVEL"
                    id="CPF_RESPONSAVEL"
                    color="#F1873B"
                    label="CPF"
                    variant="outlined"
                    size="small"
                    disabled={updateType}
                    style={{ width: '100%', maxWidth: 180 }}
                    // disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='14'
                    value={data.FONE_RESPONSAVEL || ''}
                    onChange={handleChange}
                    onBlur={handleCelularCobrança}
                    name="FONE_RESPONSAVEL"
                    id="FONE_RESPONSAVEL"
                    color="#F1873B"
                    label="Celular"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 160 }}
                    disabled={updateType}
                  />
                  <FrTextInput
                    maxLength='100'
                    value={data.EMAIL_RESPONSAVEL || ''}
                    onChange={handleChange}
                    onBlur={handleEmail}
                    name="EMAIL_RESPONSAVEL"
                    id="EMAIL_RESPONSAVEL"
                    color="#F1873B"
                    label="Email"
                    variant="outlined"
                    size="small"
                    style={{ width: '100%', maxWidth: 300 }}
                    disabled={updateType}
                  />
                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <h2>Forma de Pagamento:</h2>
                  <FrSelect
                    value={data.TIPO || ''}
                    onChange={handleChange}
                    name="TIPO"
                    id="TIPO"
                    label='Forma de Pagamento *'
                    data={comboPagamentos}
                    style={{ width: 200 }}
                    required
                    disabled={updateType}
                  />
                  <FrSelect
                    value={data.DIA_VENCIMENTO || ''}
                    onChange={handleChange}
                    name="DIA_VENCIMENTO"
                    id="DIA_VENCIMENTO"
                    label='Dia de Vencimento *'
                    data={comboDiaVencimento}
                    style={{ width: 250 }}
                    disabled={updateType}
                    required
                  />
                  <br />
                  <Zoom in={((data.TIPO === 'D') || (data.TIPO === 'A'))}>
                    <div style={{ height: (((data.TIPO === 'D') || (data.TIPO === 'A')) ? 'auto' : '0') }}>
                      <FrSelect
                        value={data.FK_BCO || ''}
                        onChange={handleChange}
                        name="FK_BCO"
                        id="FK_BCO"
                        label='Banco'
                        data={comboBancos}
                        style={{ width: 250 }}
                        required={(data.TIPO === 'D') || (data.TIPO === 'A')}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.AGENCIA || ''}
                        onChange={handleChange}
                        name="AGENCIA"
                        id="AGENCIA"
                        color="#F1873B"
                        label="Agência"
                        variant="outlined"
                        size="small"
                        required={(data.TIPO === 'D') || (data.TIPO === 'A')}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.CONTA || ''}
                        onChange={handleChange}
                        name="CONTA"
                        id="CONTA"
                        color="#F1873B"
                        label="Conta Corrente"
                        variant="outlined"
                        size="small"
                        required={(data.TIPO === 'D') || (data.TIPO === 'A')}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                    </div>
                  </Zoom>
                  <Zoom in={data.TIPO === 'C'}>
                    <div style={{ height: (data.TIPO === 'C' ? 'auto' : '0') }}>
                      <FrTextInput
                        maxLength='150'
                        value={data.NOME_CARTAO || ''}
                        onChange={handleChange}
                        name="NOME_CARTAO"
                        id="NOME_CARTAO"
                        color="#F1873B"
                        label="Nome Cartão"
                        variant="outlined"
                        size="small"
                        required={data.TIPO === 'C'}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                      <FrSelect
                        value={data.FK_BAN || ''}
                        onChange={handleChange}
                        name="FK_BAN"
                        id="FK_BAN"
                        label='Bandeira'
                        data={comboBandeiraCartao}
                        style={{ width: 200 }}
                        required={data.TIPO === 'C'}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.NUM_CARTAO || ''}
                        onChange={handleChange}
                        name="NUM_CARTAO"
                        id="NUM_CARTAO"
                        color="#F1873B"
                        label="Número do Cartão"
                        variant="outlined"
                        size="small"
                        required={data.TIPO === 'C'}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.CVC_CARTAO || ''}
                        onChange={handleChange}
                        name="CVC_CARTAO"
                        id="CVC_CARTAO"
                        color="#F1873B"
                        label="CVV"
                        variant="outlined"
                        size="small"
                        required={data.TIPO === 'C'}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.NOME_CARTAO || ''}
                        onChange={handleChange}
                        name="NOME_CARTAO"
                        id="NOME_CARTAO"
                        color="#F1873B"
                        label="Nome no Cartão"
                        variant="outlined"
                        size="small"
                        required={data.TIPO === 'C'}
                        style={{ width: 250 }}
                        disabled={updateType}
                      />
                      <FrTextInput
                        maxLength='150'
                        value={data.VCTO_CARTAO || ''}
                        onChange={handleChange}
                        name="VCTO_CARTAO"
                        id="VCTO_CARTAO"
                        color="#F1873B"
                        label="Validade"
                        variant="outlined"
                        size="small"
                        required={data.TIPO === 'C'}
                        style={{ width: 100 }}
                        disabled={updateType}
                      />
                    </div>
                  </Zoom>
                  <br />
                </div>
              </Paper>
              <Paper elevation={1} square>
                <div className="paperDiv">
                  <FrCheckBox text={
                    `Declaro estar ciente das cláusulas e condições estabelecidas no item "4" quanto à aceitação do seguro de
                  acidentes pessoais e assistência funeral, para o que confirmo, nesta data, não me encontrar enfermo nem
                  inválido, estando em perfeitas condições de saúde, estando ciente que, de acordo com o artigo 766 do Código
                  Civil Brasileiro, se tiver omitido circunstâncias que possam influir na aceitação do Seguro, perderei o direito às
                  indenizações referentes ao seguro, não me dispensando do pagamento das mensalidades vencidas e/ou
                  vincendas.`
                  } onChange={handleChange} name="checkDeclaracao" id="checkDeclaracao" checked={data.checkDeclaracao || false} />

                </div>
              </Paper>
              <br />
              <FrTextInput
                value={data.PK_PRP || ''}
                onChange={handleChange}
                id="PK_PRP"
                name="PK_PRP"
                hidden
              />
            </div>
          </Zoom>
        </form>
        <div style={{ display: (data.FK_PLA > 0 ? 'block' : 'none') }}>
          <div className="VendaregButtonsDiv">
            <button style={{ display: updateType ? 'none' : 'block' }} onClick={handleSubmit}>Enviar</button>
            <button onClick={handleCancel}>Voltar</button>
          </div>

          <FooterDelphus />
        </div>
      </div>
    </div>
  );
}

export default Propostas;
